import { Box, styled, useTheme } from "@mui/material";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";

interface IMxCardOptionProps {
  label: string;
  description?: string;
  icon?: React.ReactNode;
  selected: boolean;
  onClick: () => void;
}

export const MxCardOption = ({
  label,
  description,
  selected,
  onClick,
  icon
}: IMxCardOptionProps) => {
  const theme = useTheme();
  return (
    <CardItem selected={selected} onClick={onClick}>
      <MxTypography
        textAlign="center"
        variant="subtitle2"
        fontWeight={600}
        color={selected ? "white" : theme.palette.primary.main}
      >
        {label}
      </MxTypography>
      {icon && (
        <MxIcons size={80} color={selected ? "white" : theme.palette.primary.main}>
          {icon}
        </MxIcons>
      )}
      {description && (
        <MxTypography
          variant="overline"
          fontWeight={300}
          textAlign="center"
          color={selected ? "white" : theme.palette.grey[600]}
        >
          {description}
        </MxTypography>
      )}
    </CardItem>
  );
};

const CardItem = styled(Box)<{ selected: boolean }>(({ theme, selected }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 1,
  rowGap: 5,
  border: "1px solid",
  borderColor: selected ? theme.palette.primary.light : theme.palette.grey[300],
  padding: 5,
  borderRadius: 5,
  background: selected ? `${theme.palette.primary.main}` : "transparent",
  minHeight: 100,
  cursor: "pointer",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 0.2s ease-in-out",
  color: selected ? "white" : theme.palette.grey[600],
  "&:hover": {
    background: selected
      ? `${theme.palette.primary.light}20`
      : `${theme.palette.primary.light}20`,
    borderColor: selected ? theme.palette.primary.light : theme.palette.grey[300]
  }
}));

export default MxCardOption;
